var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ctm-cleantalk-settings" },
    [
      _vm.loading
        ? _c("div", { staticClass: "ctm-cleantalk-settings__loading" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _vm._v(" Loading…\n    ")
          ])
        : [
            _vm._m(0),
            _vm._v(" "),
            _vm.settings.access_key
              ? _c(
                  "div",
                  { staticClass: "ctm-cleantalk-settings__status-row" },
                  [
                    _c(
                      "span",
                      {
                        class: [
                          "ctm-cleantalk-settings__badge",
                          _vm.settings.status ? "is-active" : "is-inactive"
                        ]
                      },
                      [
                        _c("i", {
                          class: _vm.settings.status
                            ? "el-icon-circle-check"
                            : "el-icon-warning-outline"
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.settings.status
                                ? "Active — API key is valid"
                                : "Inactive — API key not verified"
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form",
              {
                staticClass: "ctm-cleantalk-settings__form",
                attrs: { "label-position": "top" }
              },
              [
                _c("el-form-item", { attrs: { label: "Access Key" } }, [
                  _c(
                    "div",
                    { staticClass: "ctm-cleantalk-settings__key-row" },
                    [
                      _c("el-input", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          placeholder: "Your CleanTalk access key",
                          clearable: ""
                        },
                        model: {
                          value: _vm.settings.access_key,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "access_key", $$v)
                          },
                          expression: "settings.access_key"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.verifying,
                            disabled: !_vm.settings.access_key
                          },
                          on: { click: _vm.verifyKey }
                        },
                        [_vm._v("Verify Key")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "ctm-cleantalk-settings__help" }, [
                    _vm._v(
                      "\n                    Get a free key at cleantalk.org. The key is validated when you save settings.\n                "
                    )
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.verifyResult
              ? _c(
                  "div",
                  {
                    class: [
                      "ctm-cleantalk-settings__verify-result",
                      _vm.verifyResult.ok ? "is-success" : "is-error"
                    ]
                  },
                  [
                    _c("i", {
                      class: _vm.verifyResult.ok
                        ? "el-icon-circle-check"
                        : "el-icon-circle-close"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.verifyResult.message) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ctm-cleantalk-settings__actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.saving },
                    on: { click: _vm.save }
                  },
                  [_vm._v("Save Settings")]
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-cleantalk-settings__header" }, [
      _c("span", {
        staticClass:
          "ctm-cleantalk-settings__icon dashicons dashicons-shield-alt"
      }),
      _vm._v(" "),
      _c("div", [
        _c("h2", { staticClass: "ctm-cleantalk-settings__title" }, [
          _vm._v("CleanTalk Spam Protection")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "ctm-cleantalk-settings__desc" }, [
          _vm._v(
            "\n                    Cloud-based spam filter that checks every form submission against the CleanTalk database.\n                    No CAPTCHA needed — invisible to real users. Get a free access key at\n                    "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://cleantalk.org",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("cleantalk.org")]
          ),
          _vm._v(".\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-cleantalk-settings__info-box" }, [
      _c("p", { staticClass: "ctm-cleantalk-settings__info-title" }, [
        _vm._v("How it works")
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "ctm-cleantalk-settings__info-list" }, [
        _c("li", [
          _vm._v(
            "Each form submission is checked against the CleanTalk spam database in real time."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Spam submissions are blocked before the entry is saved.")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "If the CleanTalk API is unreachable, submissions are allowed through (fail-open)."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Enable per-form in "),
          _c("strong", [_vm._v("Form Settings → Integrations → CleanTalk")]),
          _vm._v(".")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }